export function formatRelativeTime(msAgo: number): string {
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const sec = Math.floor(msAgo / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);
  if (day >= 1) return rtf.format(-day, 'day');
  if (hr >= 1) return rtf.format(-hr, 'hour');
  if (min >= 1) return rtf.format(-min, 'minute');
  return rtf.format(-sec, 'second');
}
